if (!customElements.get('natunora-listicle-results')) {
  customElements.define('natunora-listicle-results', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('.n-listicle-results__slide')];
      this.picks = [...this.querySelectorAll('[data-pick]')];
      this.track = this.querySelector('.n-listicle-results__track');
      this.stage = this.querySelector('.n-listicle-results__stage');
      this.status = this.querySelector('[role="status"]');
      this.index = 0;
      this.addEventListener('click', event => {
        const pick = event.target.closest('[data-pick]');
        const arrow = event.target.closest('[data-step]');
        if (pick) this.show(Number(pick.dataset.pick));
        if (arrow) this.show(this.index + Number(arrow.dataset.step));
      }, options);
      this.addEventListener('keydown', event => {
        const positions = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in positions)) return;
        event.preventDefault();
        this.show(positions[event.key]);
      }, options);
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.target.closest('button')) return;
        this.pointer = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      this.stage.addEventListener('pointerup', event => {
        const start = this.pointer;
        this.pointer = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(event.clientY - start.y)) this.show(this.index + (dx < 0 ? 1 : -1));
      }, options);
      this.stage.addEventListener('pointercancel', () => { this.pointer = null; }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('.n-listicle-results__slide'));
        if (index >= 0) this.show(index);
      }, options);
      this.show(0, false);
    }

    show(index, announce = true) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== this.index));
        slide.inert = i !== this.index;
      });
      this.picks.forEach(pick => {
        if (Number(pick.dataset.pick) === this.index) pick.setAttribute('aria-current', 'true');
        else pick.removeAttribute('aria-current');
      });
      if (announce) this.status.textContent = `Beispiel ${this.index + 1} von ${this.slides.length}`;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.pointer = null;
    }
  });
}
